module.exports = __webpack_public_path__ + "img/IMG_4684.eac18f6a.jpg";